export async function writeClipboard(text, mimeType = 'text/html') {
  try {
    // Focus the document to ensure clipboard operations work
    if (document.activeElement !== document.body) {
      document.body.focus();
    }

    const type = mimeType;
    const blob = new Blob([text], { type });
    const data = [new ClipboardItem({ [type]: blob })];
    await navigator.clipboard.write(data);
    return true;
  } catch (error) {
    console.error('Clipboard write failed:', error.message);
    // Fallback method for copying text when the Clipboard API fails
    if (mimeType === 'text/plain' || mimeType === 'text/html') {
      try {
        const textArea = document.createElement('textarea');
        textArea.value = text;
        textArea.style.position = 'fixed';
        textArea.style.opacity = '0';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        const successful = document.execCommand('copy');
        document.body.removeChild(textArea);
        return successful;
      } catch (fallbackError) {
        console.error('Fallback clipboard method failed:', fallbackError.message);
        return false;
      }
    }
    return false;
  }
}

export function clipBoardPayloadEncode(payload) {
  return `<!--mero-start-->
  <!--mero-data="${btoa(encodeURIComponent(JSON.stringify(payload, null, 2)))}"-->
  <!--mero-end-->`;
}

export function clipBoardPayloadDecode(text) {
  if (text && text.includes('mero-start') && text.includes('mero-end')) {
    const payload = JSON.parse(
      decodeURIComponent(window.atob(text.split('mero-data="')[1].split('"')[0]))
    );
    return payload;
  }
  return null;
}

export function removeHideProperties(node) {
  const copy = { ...node };
  Object.keys(copy).forEach((key) => {
    if (key.startsWith('_')) {
      delete copy[key];
    }
  });
  return copy;
}
